import React from 'react';
import Menu from '../components/menu';
import Icon from '../elements/icons';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { Helmet } from 'react-helmet';

// ── Passe die Dateinamen an deine tatsächlichen Bilder an ──────────────────

// Alternativ als public-Pfad (kein Import nötig):
// const zariImg1 = "/assets/zari/image1.jpg"; usw.
// ────────────────────────────────────────────────────────────────────────────

class ZARi extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        window.scrollTo(0, 0);

        const primaryColor = "#0d7377";
        const primaryGradient = "linear-gradient(135deg, #0d7377, #14a3a8)";
        const accentColor = "#f0a500";
        const accentGradient = "linear-gradient(135deg, #f0a500, #e2c044)";

        return (<>
            <Helmet>
                <meta charSet="utf-8" />
                <title>ZARi – Zentrum für Autismus Rinteln - Lebenshilfe Rinteln</title>
                <meta
                    name="description"
                    content="Zentrum für Autismus Rinteln (ZARi) der Lebenshilfe Rinteln. Heilpädagogische Intervention für Menschen im Autismus-Spektrum und Beratung für Angehörige."
                />
            </Helmet>

            <div style={{ marginTop: "100px" }} className="animate__animated animate__fadeIn pb-5">

                {this.props.mobileVersion ? "" : <Menu {...this.props} />}

                {/* Hero Section */}
                <div className="container text-center shadow p-0 rounded overflow-hidden mt-3">
                    <h3 className="p-3 text-white m-0 ff-1 shadow-sm" style={{ background: primaryGradient }}>
                        Zentrum für Autismus Rinteln (ZARi)
                    </h3>
                    <div style={{
                        background: "linear-gradient(135deg, #e0f7fa 0%, #b2dfdb 50%, #e8f5e9 100%)",
                        minHeight: "450px",
                        padding: "40px 20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        position: "relative",
                        overflow: "hidden"
                    }}>
                        <div style={{ position: "absolute", top: "20px", left: "30px", opacity: 0.15, transform: "rotate(-15deg)", color: primaryColor }}>
                            <Icon icon="FaPuzzlePiece" style={{ fontSize: "4rem" }} />
                        </div>
                        <div style={{ position: "absolute", bottom: "30px", right: "40px", opacity: 0.12, transform: "rotate(25deg)", color: primaryColor }}>
                            <Icon icon="FaPuzzlePiece" style={{ fontSize: "3rem" }} />
                        </div>
                        <div style={{ position: "absolute", top: "60px", right: "120px", opacity: 0.1, transform: "rotate(-40deg)", color: accentColor }}>
                            <Icon icon="FaPuzzlePiece" style={{ fontSize: "2.5rem" }} />
                        </div>
                        <div style={{
                            background: "rgba(255,255,255,0.9)",
                            borderRadius: "20px",
                            padding: "40px 50px",
                            backdropFilter: "blur(10px)",
                            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
                            textAlign: "center",
                            maxWidth: "750px"
                        }}>
                            <h1 className="ff-1 font-weight-bold m-0" style={{ color: primaryColor, fontSize: "3rem", letterSpacing: "3px" }}>
                                ZARi
                            </h1>
                            <p className="m-0 mt-2 mb-3" style={{ color: "#555", fontSize: "1.1rem", letterSpacing: "0.5px" }}>
                                Zentrum für Autismus Rinteln
                            </p>
                            <div className="mb-4 d-flex align-items-center justify-content-center">
                                <span className="badge px-4 py-2 text-white font-weight-bold zari-badge-pulse" style={{
                                    background: accentGradient,
                                    fontSize: "1rem",
                                    borderRadius: "50px"
                                }}>
                                    Wir haben Neuigkeiten!
                                </span>
                            </div>
                            <div style={{ color: "#333", lineHeight: "1.6" }}>
                                <p className="mb-3 text-secondary" style={{ fontSize: "1.1rem" }}>
                                    Liebe Familien,
                                </p>
                                <h4 className="font-weight-bold mb-3" style={{ color: primaryColor }}>
                                    Wir freuen uns Ihnen mitteilen zu können, dass das ZARi nun für Kinder und Jugendliche
                                    mit Wohnort im Kreis Lippe neben Porta Westfalica ebenfalls seine Türen eröffnen kann.
                                </h4>
                                <p className="mb-0 text-secondary" style={{ fontSize: "1.1rem" }}>
                                    Sie möchten uns kennenlernen und ein Bild von unserem Angebot erhalten?<br />
                                    <strong>Melden Sie sich zeitnah telefonisch, um eine unverbindliche Erstberatung zu erhalten.</strong><br />
                                    Wir freuen uns auf Sie!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='container mt-5'>



                    {/* Info Cards */}
                    <div className='row mb-5 d-flex align-items-stretch'>
                        <div className='col-md-6 col-lg-4 mb-4'>
                            <div className="bg-white rounded shadow-sm p-4 h-100 zari-hover-card" style={{ borderLeft: `5px solid ${primaryColor}` }}>
                                <h4 className="mb-3 d-flex align-items-center" style={{ color: primaryColor }}>
                                    <div className="mr-2"><Icon icon="FaHandHoldingHeart" /></div> Heilpädagogische Intervention
                                </h4>
                                <p className="text-secondary" style={{ fontSize: "1.05rem", lineHeight: "1.7" }}>
                                    Wir bieten zukünftig heilpädagogische Intervention für Menschen im Autismus-Spektrum sowie ein umfangreiches Beratungsangebot für angehörige Familien.
                                </p>
                            </div>
                        </div>
                        <div className='col-md-6 col-lg-4 mb-4'>
                            <div className="bg-white rounded shadow-sm p-4 h-100 zari-hover-card" style={{ borderLeft: `5px solid ${accentColor}` }}>
                                <h4 className="mb-3 d-flex align-items-center" style={{ color: accentColor }}>
                                    <div className="mr-2"><Icon icon="FaUsers" /></div> Förderung & Stärkung
                                </h4>
                                <p className="text-secondary" style={{ fontSize: "1.05rem", lineHeight: "1.7" }}>
                                    Die Autismus-Förderung im ZARi dient dazu, soziale, alltagspraktische und kommunikative Fähigkeiten des Menschen im Autismus-Spektrum zu stärken.
                                </p>
                            </div>
                        </div>
                        <div className='col-md-12 col-lg-4 mb-4'>
                            <div className="bg-white rounded shadow-sm p-4 h-100 zari-hover-card" style={{ borderLeft: `5px solid #6c5ce7` }}>
                                <h4 className="mb-3 d-flex align-items-center" style={{ color: "#6c5ce7" }}>
                                    <div className="mr-2"><Icon icon="FaComments" /></div> Beratung & Sensibilisierung
                                </h4>
                                <p className="text-secondary" style={{ fontSize: "1.05rem", lineHeight: "1.7" }}>
                                    Das ZARi berät zusätzlich bei der Auseinandersetzung mit der eigenen Diagnose und sensibilisiert das Umfeld für die Bedarfe der Betroffenen.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* ── FOTO-GALERIE ─────────────────────────────────────────── */}
                    <div className="row mb-5">
                        {/* Layout: 1 großes Bild links | 3 rechts gestapelt */}
                        <div className="col-12 col-md-7 mb-3 mb-md-0" style={{ paddingRight: "6px" }}>
                            <div className="zari-photo zari-photo-main">
                                <img src={"/assets/zari/1.jpg"} alt="ZARi – Einblick 1" />
                            </div>
                        </div>

                        <div className="col-12 col-md-5 d-flex flex-column" style={{ paddingLeft: "6px" }}>
                            {/* Mittelgroß oben */}
                            <div className="zari-photo zari-photo-sm mb-2">
                                <img src={"/assets/zari/2.png"} alt="ZARi – Einblick 2" />
                            </div>
                            {/* Zwei kleine nebeneinander unten */}
                            <div className="d-flex" style={{ flex: 1, gap: "8px" }}>
                                <div className="zari-photo zari-photo-xs" style={{ flex: 1 }}>
                                    <img src={"/assets/zari/3.jpg"} alt="ZARi – Einblick 3" />
                                </div>
                                <div className="zari-photo zari-photo-xs" style={{ flex: 1 }}>
                                    <img src={"/assets/zari/4.png"} alt="ZARi – Einblick 4" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* ── ENDE GALERIE ─────────────────────────────────────────── */}

                    {/* CTA Section */}
                    <div className="row mb-5">
                        <div className="col-12">
                            <div className="text-dark rounded shadow p-4 p-md-5 d-flex flex-column flex-md-row align-items-center justify-content-between" style={{ background: accentGradient }}>
                                <div className="mb-4 mb-md-0 flex-grow-1 pr-md-4">
                                    <h3 className="font-weight-bold mb-3 d-flex align-items-center">
                                        <div className="mr-2"><Icon icon="FaQuestionCircle" /></div> Haben Sie Interesse oder Fragen?
                                    </h3>
                                    <p className="mb-0" style={{ fontSize: "1.1rem" }}>
                                        Gerne beraten wir Sie zu den Möglichkeiten der Autismus-Förderung für Sie oder Ihre Angehörigen.
                                    </p>
                                </div>
                                <div className="ml-md-4">
                                    <Link to="/kontakt" className="btn btn-dark btn-lg shadow rounded px-4 py-3 font-weight-bold text-nowrap zari-modern-btn">Kontakt aufnehmen</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Ansprechpartnerin Card */}
                    <div className="row m-0 justify-content-center mb-4">
                        <div className="col-12 col-lg-10 bg-white shadow rounded p-0 overflow-hidden zari-contact-card">
                            <div className="p-3 text-white text-center font-weight-bold" style={{ fontSize: "1.2rem", letterSpacing: "1px", background: primaryGradient }}>
                                <div className="d-flex align-items-center justify-content-center">
                                    <div className="mr-2"><Icon icon="Person" /></div> Ihre Ansprechpartnerin
                                </div>
                            </div>
                            <div className="row m-0 p-4 p-md-5 align-items-center">
                                <div className="col-12 col-md-5 text-center mb-4 mb-md-0">
                                    <div className="position-relative d-inline-block">
                                        <img src={"/assets/zari/hanna.jpg"} className="rounded-circle shadow-sm" style={{ width: "200px", height: "200px", objectFit: "cover", border: `5px solid ${primaryColor}` }} alt="Hanna Bettin" />
                                    </div>
                                </div>
                                <div className="col-12 col-md-7 text-center text-md-left text-secondary pl-md-4">
                                    <h2 className="text-dark font-weight-bold mb-1">Hanna Bettin</h2>
                                    <div className="d-flex align-items-center justify-content-center justify-content-md-start mb-3 mt-4" style={{ fontSize: "1.1rem" }}>
                                        <div className="rounded-circle p-2 mr-3 text-white shadow-sm d-flex align-items-center justify-content-center" style={{ width: "45px", height: "45px", background: primaryColor }}>
                                            <Icon icon="Phone" />
                                        </div>
                                        <span className="font-weight-bold text-dark">05751 – 89 104 340</span>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center justify-content-md-start mb-3" style={{ fontSize: "1.1rem" }}>
                                        <div className="rounded-circle p-2 mr-3 text-white shadow-sm d-flex align-items-center justify-content-center" style={{ width: "45px", height: "45px", background: primaryColor }}>
                                            <Icon icon="FaMobileAlt" />
                                        </div>
                                        <span className="font-weight-bold text-dark">0171 – 44 434 45</span>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center justify-content-md-start mb-4" style={{ fontSize: "1.1rem" }}>
                                        <div className="rounded-circle p-2 mr-3 text-white shadow-sm d-flex align-items-center justify-content-center" style={{ width: "45px", height: "45px", background: primaryColor }}>
                                            <Icon icon="Mail" />
                                        </div>
                                        <a href="mailto:zari@lebenshilfe-rinteln.de" className="font-weight-bold" style={{ textDecoration: "underline", color: primaryColor }}>zari@lebenshilfe-rinteln.de</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <style dangerouslySetInnerHTML={{
                    __html: `
                    .zari-hover-card {
                        transition: all 0.3s ease;
                        border: 1px solid #f8f9fa;
                    }
                    .zari-hover-card:hover {
                        transform: translateY(-8px);
                        box-shadow: 0 1rem 3rem rgba(0,0,0,.15)!important;
                        border-color: #e9ecef;
                    }
                    .zari-modern-btn {
                        transition: all 0.2s ease;
                        border-radius: 50px !important;
                    }
                    .zari-modern-btn:hover {
                        transform: translateY(-3px);
                        box-shadow: 0 0.5rem 1.5rem rgba(0,0,0,.2)!important;
                        background-color: #212529;
                    }
                    .zari-contact-card { transition: all 0.3s ease; }
                    .zari-contact-card:hover { box-shadow: 0 1rem 3rem rgba(0,0,0,.15)!important; }
                    .zari-badge-pulse {
                        animation: zariBadgePulse 2s ease-in-out infinite;
                    }
                    @keyframes zariBadgePulse {
                        0%, 100% { transform: scale(1); }
                        50% { transform: scale(1.05); }
                    }

                    /* ── Foto-Galerie ── */
                    .zari-photo {
                        overflow: hidden;
                        border-radius: 10px;
                        box-shadow: 0 4px 18px rgba(0,0,0,0.10);
                        background: #e9ecef;
                    }
                    .zari-photo img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        display: block;
                        transition: transform 0.5s ease;
                    }
                    .zari-photo:hover img {
                        transform: scale(1.05);
                    }

                    /* Großes Bild links */
                    .zari-photo-main {
                        height: 420px;
                    }

                    /* Mittelgroß oben rechts */
                    .zari-photo-sm {
                        height: 196px;
                    }

                    /* Zwei kleine unten rechts */
                    .zari-photo-xs {
                        height: 196px;
                    }

                    @media (max-width: 767px) {
                        .zari-photo-main { height: 240px; }
                        .zari-photo-sm   { height: 160px; }
                        .zari-photo-xs   { height: 120px; }
                    }
                `}} />
            </div>
        </>);
    }
}

export default ZARi;